var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_81_16912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.74457 17.7545C-0.248189 16.0495 -0.24819 13.9505 0.74457 12.2455L5.97447 3.26344C6.97 1.55366 8.81251 0.500002 10.8068 0.500002L21.2458 0.500002C23.2401 0.500002 25.0826 1.55366 26.0782 3.26344L31.3081 12.2455C32.3008 13.9505 32.3008 16.0495 31.3081 17.7545L26.0782 26.7366C25.0826 28.4463 23.2401 29.5 21.2458 29.5L10.8068 29.5C8.81251 29.5 6.97 28.4463 5.97447 26.7366L0.74457 17.7545Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88372 17.0913C1.12967 15.7962 1.12967 14.2038 1.88372 12.9087L7.11362 3.92672C7.87073 2.62643 9.27707 1.81818 10.8068 1.81818L21.2458 1.81818C22.7756 1.81818 24.1819 2.62643 24.939 3.92672L30.1689 12.9087C30.923 14.2038 30.923 15.7962 30.1689 17.0913L24.939 26.0733C24.1819 27.3736 22.7756 28.1818 21.2458 28.1818L10.8068 28.1818C9.27707 28.1818 7.87073 27.3736 7.11362 26.0733L1.88372 17.0913Z",
    stroke: "#00B67A",
    strokeWidth: 2.63636
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8931 10.4211L13.7352 19.579L9.15625 15",
    stroke: "white",
    strokeWidth: 2.28947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_81_16912",
    x: -21.7059,
    y: -21.2059,
    width: 75.4626,
    height: 72.4118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.853
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_81_16912"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_81_16912",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.33937
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66969
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_81_16912"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.3847
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_81_16912",
    result: "effect3_innerShadow_81_16912"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonSuccess);
export default __webpack_public_path__ + "static/media/hexagon-success.30554249c9dff3062de351e2778e7475.svg";
export { ForwardRef as ReactComponent };